<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section">
          <div class="container">
            {{ $t('NF3SC1') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  components: {},
  data() {
    return {}
  },
  mounted() {
    let self = this
    self.request(() =>
      self
        .postRequestContractSignature({
          name: self.neofintechData.userData.firstName,
          email: self.neofintechData.email,
          ccRecipients: self.neofintechData.ccRecipients,
          requestId: self.neofintechData.requestId,
          data: {
            textfield_01: self.neofintechData.userData.firstName,
            textfield_02: self.neofintechData.userData.lastName,
            textfield_03: self.neofintechData.userData.companyName,
            textfield_04: self.neofintechData.userData.jobPosition,
            textfield_05: self.neofintechData.userData.jobCity,
            textfield_06: self.neofintechData.userData.jobCountry,
            textfield_07: self.neofintechData.userData.contactPhone,
            textfield_08: self.neofintechData.userData.email
          }
        })
        .then(function(response) {
          console.log(response)
        })
    )
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  methods: {
    ...mapActions('onBoard', ['postRequestContractSignature'])
  }
}
</script>
